export const SendSampleEquipmentBreadCrumbData = [
  { path: "/page/equipment/sendsample", name: "设备" },
  { path: "/page/equipment/sendsample", name: "试试如意派样设备" },
];

export const Business = [
  { path: "/page/business/business", name: "运营商管理" },
  { path: "/page/business/business", name: "运营商管理" },
];

export const Evaluate = [
  { path: "/page/business/business", name: "运营商管理" },
  { path: "/page/business/business", name: "评价管理" },
];

export const Split = [
  { path: "/page/business/business", name: "运营商管理" },
  { path: "/page/business/business", name: "分账管理" },
];

export const Split_Detail = [
  { path: "/page/business/business", name: "运营商管理" },
  { path: "/page/business/business", name: "分账管理" },
  { path: "/page/business/business", name: "分账详情" },
];

export const Business_Position = [
  { path: "/page/business/business", name: "运营商管理" },
  { path: "/page/business/business", name: "运营商管理" },
  { path: "/page/business/business", name: "查看点位" },
];

export const Split_Record = [
  { path: "/page/business/business", name: "运营商管理" },
  { path: "/page/business/business", name: "分账管理" },
  { path: "/page/business/business", name: "提现记录" },
];

export const AccountRules = [
  { path: "/page/business/business", name: "试试如意运营" },
  { path: "/page/business/business", name: "计费规则" },
];

export const Operate_Sendearnings = [
  { path: "/page/business/business", name: "试试如意运营" },
  { path: "/page/business/business", name: "派样收益" },
];

export const Operate_Evaluation = [
  { path: "/page/business/business", name: "试试如意运营" },
  { path: "/page/business/business", name: "测评管理" },
];

export const Brand = [{ path: "/page/business/business", name: "品牌商管理" }];

export const Brand_Position = [
  { path: "/page/business/business", name: "品牌商管理" },
  { path: "/page/business/business", name: "查看投放点位" },
];

export const Brand_Detail = [
  { path: "/page/business/business", name: "品牌商管理" },
  { path: "/page/business/business", name: "查看充值明细" },
];

export const Brand_Consumption = [
  { path: "/page/business/business", name: "品牌商管理" },
  { path: "/page/business/business", name: "查看消费明细" },
];

export const Business_Brand = [
  { path: "/page/business/business", name: "运营商管理" },
  { path: "/page/business/business", name: "运营商管理" },
  { path: "/page/business/business", name: "查看点位" },
  { path: "/page/business/business", name: "查看投放品牌商" },
];

export const Evaluation_Detail = [
  { path: "/page/business/business", name: "试试如意运营" },
  { path: "/page/business/business", name: "测评管理" },
  { path: "/page/business/business", name: "查看详情" },
];
